import { FC } from "react";
import { useTrackEvent } from "../../../lib/tracking/useTrack";
import { ChatIcon } from "../ChatIcon";
import type { WelcomeBannerProps } from "./WelcomeBanner.types";

import styles from './WelcomeBanner.module.css';

export const WelcomeBanner: FC<WelcomeBannerProps> = ({ onClick }) => {
    const trackEvent = useTrackEvent();

    const handleShowChatbot = () => {
        trackEvent('chatbot_open', {});
        onClick();
    }

    return (
        <div className={styles.welcomeBanner} onClick={handleShowChatbot}>
            <ChatIcon type="fill" />
            <div>
                <h3>
                    Meet your new AI Waiter ✨
                </h3>
                <p>
                    Chat now to get meal recommendations instantly.
                </p>
            </div>
        </div>
    );
};